// formatDateStr — pure formatting of a Date as a local `YYYY-MM-DD` string.
//
// Extracted verbatim from `FlightLookup.js` (module-level `formatDateStr` helper)
// as part of the behavior-preserving refactor (issue #240). Uses the Date's local
// getters (not UTC) so the produced day matches the user's local calendar day,
// exactly as the source did.
//
// React-free and side-effect-free. The source did not guard a missing/invalid
// `Date` argument (it called `.getFullYear()` directly), so no guard is added
// here — behavior is identical.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Formats a Date object as a local `YYYY-MM-DD` string.
 *
 * @param {Date} d - The date to format.
 * @returns {string} The `YYYY-MM-DD` string in local time.
 */
export function formatDateStr(d) {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export default formatDateStr;
